import { MetaType } from '@lmp/eduki-routes';
import React, { FC, ReactNode, useEffect } from 'react';
import translation from '../../languages';

type DocumentMetaPropsType = MetaType & {
    children?: ReactNode;
};

const DocumentMeta: FC<DocumentMetaPropsType> = (props) => {
    const { title, description, canonical, image, keywords, robots, auto, name, property, children } = props;

    useEffect(() => {
        const showTitle = title && typeof description !== 'function';
        const showDescription = description && typeof description !== 'function';

        if (showTitle) {
            document.title = title;
        }

        const setMetaTag = (name: string, content: string, attr: 'name' | 'property' = 'name') => {
            let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);

            if (!tag) {
                tag = document.createElement('meta');
                tag.setAttribute(attr, name);
                document.head.appendChild(tag);
            }
            tag.setAttribute('content', content);
        };

        if (image) {
            setMetaTag('og:image', image, 'property');
            setMetaTag('og:image:url', image, 'property');
            setMetaTag('og:image:width', '210', 'property');
            setMetaTag('og:image:height', '210', 'property');
            setMetaTag('og:image:type', 'image/png', 'property');
        }

        if (robots) {
            setMetaTag('robots', robots);
        }

        if (showDescription) {
            setMetaTag('description', description);
        }
        setMetaTag('keywords', keywords ?? '');

        if (canonical) {
            let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');

            if (!link) {
                link = document.createElement('link');
                link.rel = 'canonical';
                document.head.appendChild(link);
            }
            link.href = canonical;
        }

        if (auto?.ograph) {
            if (showTitle) {
                setMetaTag('og:title', title, 'property');
            }

            if (showDescription) {
                setMetaTag('og:description', description, 'property');
            }

            if (canonical) {
                setMetaTag('og:url', canonical, 'property');
            }
        }

        if (name) {
            Object.entries(name).forEach(([key, value]) => {
                if (value) {
                    setMetaTag(key, value, 'name');
                }
            });
        }

        if (property) {
            Object.entries(property).forEach(([key, value]) => {
                if (value) {
                    setMetaTag(key, value, 'property');
                }
            });
        }
    }, [title, description, canonical, robots, keywords, auto?.ograph, image]);

    return <div className='meta-test'>{children}</div>;
};

// export default MetaWrapper;

export default DocumentMeta;
